module.exports = __webpack_public_path__ + "static/media/orientation-portrait.c18021d6.svg";